import { Box, Typography, Button } from "@mui/material";
import PageSection from "./PageSection";
import { radius, heroColors, sectionColors } from "../styles/tokens";
import { Link as RouterLink } from "react-router-dom"; //kept JIC
import { useSiteTheme } from "../theme/ThemeContext";

export default function HeroSection() {
  const { palette } = useSiteTheme();
  return (
    <PageSection bg={palette.hero} sx={{ pt: { xs: 1, md: 2 } }}>
      <Box
        sx={{
          position: "relative",
          minHeight: { xs: 360, sm: 300, md: 440 }, //{ xs: 360, sm: 400, md: 440 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          borderRadius: radius.surface,
          bgcolor: heroColors.bg,
          mb: { xs: 4, sm: 5, md: 0 },
        }}
      >
        <Box
          component="img"
          src="/images/icon-hero2-700.webp"
          srcSet="
            /images/icon-hero2-480.webp 480w,
            /images/icon-hero2-700.webp 700w,
            /images/icon-hero2-900.webp 900w
          "
          sizes="100vw"
          alt="Hand-painted Orthodox icon artworks"
          loading="eager"
          fetchPriority="high"
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
          }}
        />

        <Box
          // OverLay
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 2,
            px: { xs: 3, md: 5 },
            py: { xs: 3, sm: 4, md: 4 },
            backgroundColor: heroColors.overlay,
            // backdropFilter: 'blur(0.5px)',
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              pt: { xs: 2, sm: 3, md: 4 }, //pt: { xs: 3, sm: 5, md: 6 },
              maxWidth: 800, //680,
            }}
          >
            {/* <Typography
              sx={{
                fontSize: { xs: '1.8rem', md: '2.3rem' },
                letterSpacing: '0.08em',
                color: heroColors.text,
                mb: 2,
              }}
            >
              Hand painted icons 
            </Typography> */}

            {/* <Typography
              sx={{
                pt: { xs: 2, sm: 3, md: 4 }, //pt: { xs: 3, sm: 5, md: 6 },
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.6,
                color: heroColors.text,
              }}
            >
              Icons painted at home by me for sale here or contact me to commission an icon.
            </Typography> */}
          </Box>

          {/* <Button
            component={RouterLink}
            to="/artworks"
            variant="contained"
            sx={{
              mb: { xs: 0, sm: 1, md: 1 }, //mb: { xs: 2, sm: 3, md: 4 },
              px: 3,
              py: 1.25,
              borderRadius: radius.button,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              backgroundColor: heroColors.button, 
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: heroColors.buttonHover, 
                boxShadow: 'none',
              },
            }}
          >
            View All
          </Button>  */}
        </Box>
      </Box>
    </PageSection>
  );
}
